import React, { useRef, useState } from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import FluidImage from 'src/utils/FluidImage'
import Heading from 'src/components/Heading'
import Label from 'src/components/Label'
import Button from 'src/components/Button'
import Wave from 'src/utils/Wave'
import PlayButton from "src/images/play_button.svg";
import YouTube from "react-youtube";

const SplitWithImage = ({ blok }) => {
    const vidRef = useRef(false);
    const [hide, setHide] = useState(false);
    const handlePlayVideo = () => {
      vidRef.current.play();
      setHide(true);
    };

      const _onReady = (event) => {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
      };
    const hasNonWhiteBackground = (blok.dark_background || blok.black_background) ? true : false
    const topWave = (blok.wave_position !== 'bottom' && hasNonWhiteBackground) ? true : false
    const bottomWave = (blok.wave_position !== 'top' && hasNonWhiteBackground) ? true : false
    const bottomPadding = (blok.wave_position === 'top' && hasNonWhiteBackground) ? true : false
    const topPadding = (blok.wave_position === 'bottom' && hasNonWhiteBackground) ? true : false
    return (
        <SbEditable content={blok}>
            <div>
                {topWave && <Wave className={blok.black_background ? 'fill-black' : 'fill-denimblue'} flip scale/>}
                <div className={`relative ${blok.black_background ? 'bg-black' : blok.dark_background ? 'bg-denimblue' : 'bg-white'}`}>
                    <div 
                        className={`max-w-7xl mx-auto px-6 
                        ${hasNonWhiteBackground ? 'py-12' : 'lg:my-24 my-12'}
                        ${bottomPadding && 'lg:pb-24'}
                        ${topPadding && 'lg:pt-24'}
                        `}
                    >
                        <p className={`text-center text-lightblue-300 uppercase font-semibold tracking-[1px] text-[0.6875rem] mb-6`}>{blok.label}</p>
                        <Heading size="h2" className={`brightgreenBold text-center max-w-3xl mx-auto ${hasNonWhiteBackground ? '!text-white' : 'text-darkblue'}`}>
                            <RichText>{blok.title}</RichText>
                        </Heading>
                        <div className={`flex lg:flex-row flex-col justify-center items-center lg:mt-14 mt-10 lg:gap-20 md:gap-14 gap-10`}>
                        <div className={`relative ${blok.youtube_video?'w-full':'max-w-7xl'} mx-auto ` }>
                        <div className={`relative ${blok.youtube_video?'w-full':'max-w-7xl'} mx-auto`}>
                        {blok.youtube_video ? (
                            <div className="relative  z-10 rounded-xl w-full shadow-2xl">
                            <YouTube
                                videoId={blok.youtube_video?.match(/[?&]v=([^&]+)/)?.[1]}
                                containerClassName="rounded-xl z-10 block w-full h-full object-cover not-prose" 
                                iframeClassName="rounded-xl z-10 block w-full h-full  object-cover not-prose"
                                onReady={_onReady}
                            />
                            </div>
                        ) : (
                            blok.video?.filename &&
                            <div
                            className="rounded-md shadow-md mb-6 w-40 object-cover" style={{ height: "42rem",width:"42rem" }}
                            //  className="relative  z-10 rounded-xl shadow-2xl "
                             >
                            <video
                                src={blok.cdn_video ? blok.cdn_video : blok.video?.filename}
                                type="video/mp4"
                                preload="auto"
                                controls
                                width="1920"
                                height="1080"
                                muted
                                controlsList="nodownload"
                                ref={vidRef} 
                                className="rounded-xl z-10 block w-full h-full object-cover not-prose"
                            >
                                Sorry, your browser doesn't support embedded videos.
                            </video>
                            <div
                                onClick={handlePlayVideo}
                                onKeyDown={handlePlayVideo}
                                role="button"
                                tabIndex="0"
                                className={`rounded-xl absolute block z-10 top-0 left-0 w-full h-full object-cover cursor-pointer transition-all duration-500 ease-in-out focus:outline-none outline-none ${
                                hide ? 'opacity-0 invisible' : 'opacity-100 visible'
                                }`}
                            >
                                <FluidImage
                                className={` w-full h-full rounded-lg object-cover${hasNonWhiteBackground ? '' : 'shadow-lg'} ${blok.flip && 'lg:order-last'}`}
                                image={blok.image}
                                />
                                <div
                                className={`absolute z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 sm:h-20 h-12 sm:w-20 w-12 rounded-full inset-0 text-white opacity-80`}
                                >
                                <PlayButton className="w-full h-full" />
                                </div>
                            </div>
                            </div>
                        )}
                        </div>
                        </div>
                        {!blok.video?.filename && !blok.youtube_video &&<FluidImage image={blok.image} className={`lg:w-7/12 w-full md:ml-[-65px] rounded-lg ${hasNonWhiteBackground ? '' : 'shadow-lg'} ${blok.flip && 'lg:order-last'}`}/>}
                            <div className={`lg:w-5/12 w-full lg:text-left text-center`}>
                                <div className={`prose lg:max-w-md ${hasNonWhiteBackground ? 'text-white' : 'text-darkblue-700'}`}>
                                    <RichText>{blok.content}</RichText>
                                </div>
                                <Button
                                    to={blok.button_target?.cached_url}
                                    className="bg-brightgreen hover:bg-brightgreenhover before:content-[attr(before)] mt-8"
                                    before={blok.button_text}
                                    target={blok.open_in_new_tab === true && '_blank'}
                                >
                                    {blok.button_text}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                {bottomWave && <Wave className={blok.black_background ? 'fill-black' : 'fill-denimblue'} scale/>}
            </div>
        </SbEditable>
    )
}

export default SplitWithImage
